import { AvatarPlaceholder } from '@99designs/common/components/AvatarPlaceholder';
import { Color, MAX_DESIGNERS } from 'projects/consts';
import React from 'react';
import Avatar from './Avatar';
import { default as Tooltip } from './StoredPopoverCard';

interface TooltipCopy {
    heading: string;
    message: string;
    storageKey: string;
}

interface Props {
    onRemoveDesigner: (index: number) => void;
    color?: Color;
    selectDesignersCopy: TooltipCopy;
    confirmDesignersCopy: TooltipCopy;
    designers: { id: number; displayName: string }[];
    showTooltips?: boolean;
}

const SquarespaceDesignerSelection: React.SFC<Props> = ({
    designers,
    onRemoveDesigner,
    color,
    selectDesignersCopy,
    confirmDesignersCopy,
    showTooltips = false,
}) => {
    return (
        <div className="designer-selection">
            {designers.map((designer, idx) => (
                <div key={designer.id} className="designer-selection__item">
                    {showTooltips && idx === MAX_DESIGNERS - 1 ? (
                        <Tooltip
                            heading={confirmDesignersCopy.heading}
                            message={confirmDesignersCopy.message}
                            storageKey={confirmDesignersCopy.storageKey}
                            storageSource={localStorage}
                            color={color}
                        >
                            <Avatar userId={designer.id} onRemove={onRemoveDesigner} />
                        </Tooltip>
                    ) : (
                        <Avatar userId={designer.id} onRemove={onRemoveDesigner} />
                    )}
                </div>
            ))}
            {designers.length < MAX_DESIGNERS && (
                <div key="placeholder" className="designer-selection__item">
                    {showTooltips && designers.length !== 0 ? (
                        <Tooltip
                            heading={selectDesignersCopy.heading}
                            message={selectDesignersCopy.message}
                            storageKey={selectDesignersCopy.storageKey}
                            storageSource={localStorage}
                            color={color}
                        >
                            <AvatarPlaceholder title={__('Select another designer.')} />
                        </Tooltip>
                    ) : (
                        <AvatarPlaceholder title={__('Select another designer.')} />
                    )}
                </div>
            )}
        </div>
    );
};

export default SquarespaceDesignerSelection;
